import React, { useState } from 'react';
import SearchForm from '../components/SearchForm';
import SearchResults from '../components/SearchResults';
import grantService from '../services/grantService';
import './SearchPage.css';

const SearchPage = () => {
  const [searchResults, setSearchResults] = useState(null);
  const [error, setError] = useState(null);

  const handleSearch = async (searchParams) => {
    try {
      setError(null);
      const response = await grantService.searchGrants(searchParams);
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error searching grants:', error);
      setError('An error occurred while searching for grants. Please try again.');
    }
  };

  const handleExport = (records) => {
    if (!records || records.length === 0) return;

    // Generate CSV content
    const csvContent = grantService.exportToCSV(records);

    // Create a Blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `california-grants-${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="search-page">
      <h1>California Grants Search</h1>
      <p className="intro-text">
        Search for grants awarded by the state of California. Enter an organization name
        to find all grants they have received.
      </p>

      <SearchForm onSearch={handleSearch} />

      {error && <div className="error-message">{error}</div>}

      {searchResults && searchResults.records && searchResults.records.length === 0 && (
        <div className="no-results card">
          <p>No grants found for the specified criteria. Please try different search parameters.</p>
        </div>
      )}

      {searchResults && searchResults.records && searchResults.records.length > 0 && (
        <SearchResults results={searchResults} onExport={handleExport} />
      )}
    </div>
  );
};

export default SearchPage;